import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';
import { Modal, Button } from '@fuxi/eevee-ui';
import { useAntModal } from '@fuxi/eevee-hooks';
import { Avatar, DesensitizeCountryPhone } from 'common-package/src/components';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { YAOTAI_DEFAULT_AVATAR } from '@commonPackage/constants';
import styles from './MobileConflictModal.module.less';

const cx = classNames.bind(styles);

export type ConflictUserInfo = {
  name: string;
  phone: string;
};

type Props = {
  onClose?: () => void;
};

export type MobileConflictModalRef = ModalRef & {
  setConflictUserInfo: React.Dispatch<React.SetStateAction<ConflictUserInfo>>;
};

export const MobileConflictModal = forwardRef<MobileConflictModalRef, Props>(({ onClose }: Props, ref) => {
  const [conflictUserInfo, setConflictUserInfo] = useState<ConflictUserInfo>({
    name: '',
    phone: '',
  });
  const { t } = useTranslation();
  const { showModal, closeModal, commonAntModalProps } = useAntModal();
  const { name, phone } = conflictUserInfo;

  useImperativeHandle(ref, () => {
    return {
      showModal,
      setConflictUserInfo,
    };
  });

  const onModalClose = () => {
    closeModal();
    onClose?.();
  };

  return (
    <Modal centered footer={null} width={524} {...commonAntModalProps} onCancel={onModalClose}>
      <div className={cx('modal-content')}>
        <div className={cx('title')}>
          <ExclamationCircleFilled
            className="mr-xs"
            style={{
              color: 'var(--warning-color)',
              fontSize: 20,
            }}
          />
          {t('account.bindConflictTitle')}
        </div>
        <div className={cx('tip')}>
          {t('account.conflictMobileError')}
          {t('account.conflictMobileText')} <DesensitizeCountryPhone phone={phone} />{' '}
          {t('account.conflictMobileDetail')}
        </div>
        <div className={cx('account-mes-wrapper')}>
          <Avatar className={cx('user-avatar')} size={48} img={YAOTAI_DEFAULT_AVATAR} />
          <p className={cx('account-mes-content')}>{name}</p>
        </div>
        <Button type="primary" className={cx('understood-btn')} onClick={onModalClose}>
          {t('account.gotIt')}
        </Button>
      </div>
    </Modal>
  );
});

export default MobileConflictModal;
